"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { useTranslations } from "next-intl";
import { useParams, useRouter, useSearchParams } from "next/navigation";
import { useSearchUiStore } from "@/features/search/model/ui/store";
import { useSearch } from "@/shared/hooks/useSearch";
import { useRouteStore } from "@/shared/stores/data/store";
import { Icon } from "@/shared/ui/atoms";
import { CustomButton } from "@/shared/ui/molecules";
import { useGetLocale } from "@/shared/hooks/useGetLocale";
interface SearchBarProps {
  backButton?: boolean;
}
const SearchBar = t0 => {
  const $ = _c(58);
  const {
    backButton: t1
  } = t0;
  const backButton = t1 === undefined ? false : t1;
  const router = useRouter();
  const locale = useGetLocale();
  const t = useTranslations();
  const pathParams = useParams();
  const searchParams = useSearchParams();
  let t2;
  if ($[0] !== searchParams) {
    t2 = searchParams?.get("treatment") ? `&treatment=${searchParams?.get("treatment")}` : "";
    $[0] = searchParams;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const treatmentQuery = t2;
  let t3;
  if ($[2] !== searchParams) {
    t3 = searchParams?.get("query") || "";
    $[2] = searchParams;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const initialSearchValue = t3;
  const {
    updateRecentSearchKeywordList
  } = useSearch();
  const {
    isSearchBarFocused,
    setIsSearchBarFocused,
    keyword,
    setKeyword,
    selectedSubRegions
  } = useSearchUiStore();
  let t4;
  if ($[4] !== selectedSubRegions) {
    t4 = () => {
      let queryRegion = "";
      if (selectedSubRegions.length > 0) {
        queryRegion = `&region=${selectedSubRegions.map(_temp).join(",")}`;
      }
      return queryRegion;
    };
    $[4] = selectedSubRegions;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const getRegionQuery = t4;
  let t5;
  if ($[6] !== getRegionQuery || $[7] !== keyword || $[8] !== pathParams?.locale || $[9] !== router || $[10] !== setKeyword || $[11] !== treatmentQuery || $[12] !== updateRecentSearchKeywordList) {
    t5 = clearKeyword => {
      updateRecentSearchKeywordList(keyword);
      setKeyword(keyword);
      const query = clearKeyword ? "" : `query=${keyword}`;
      router.push(`/${pathParams?.locale}/search/result?${query}${getRegionQuery()}${treatmentQuery}`);
    };
    $[6] = getRegionQuery;
    $[7] = keyword;
    $[8] = pathParams?.locale;
    $[9] = router;
    $[10] = setKeyword;
    $[11] = treatmentQuery;
    $[12] = updateRecentSearchKeywordList;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const search = t5;
  let t6;
  if ($[14] !== search || $[15] !== setKeyword) {
    t6 = () => {
      setKeyword("");
      search(true);
    };
    $[14] = search;
    $[15] = setKeyword;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  const handleClear = t6;
  let t7;
  if ($[17] !== locale || $[18] !== pathParams?.locale || $[19] !== router) {
    t7 = () => {
      useRouteStore.getState().setIsGoingBack(true);
      const prev = useRouteStore.getState().popPath(locale);
      router.push(prev || `/${pathParams?.locale}`);
    };
    $[17] = locale;
    $[18] = pathParams?.locale;
    $[19] = router;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  const handleBack = t7;
  let t8;
  let t9;
  if ($[21] !== initialSearchValue || $[22] !== setKeyword) {
    t8 = () => {
      setKeyword(initialSearchValue);
    };
    t9 = [initialSearchValue, setKeyword];
    $[21] = initialSearchValue;
    $[22] = setKeyword;
    $[23] = t8;
    $[24] = t9;
  } else {
    t8 = $[23];
    t9 = $[24];
  }
  useEffect(t8, t9);
  let t10;
  if ($[25] !== backButton || $[26] !== handleBack) {
    t10 = backButton && <CustomButton onClick={handleBack} className="min-w-[24px] w-fit flex items-center justify-center flex-shrink-0"><Icon src="/icons/direction-black.svg" alt="back" width={24} /></CustomButton>;
    $[25] = backButton;
    $[26] = handleBack;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Icon src="/icons/search.svg" alt="search" width={24} className="flex-shrink-0" />;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== t) {
    t12 = t("commonSearch.placeholder");
    $[29] = t;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== setIsSearchBarFocused || $[32] !== setKeyword) {
    t13 = e => {
      setKeyword(e.target.value);
      setIsSearchBarFocused(true);
    };
    $[31] = setIsSearchBarFocused;
    $[32] = setKeyword;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] !== search || $[35] !== setIsSearchBarFocused) {
    t14 = e_0 => {
      if (e_0.nativeEvent.isComposing) {
        return;
      }
      if (e_0.key === "Enter") {
        search();
        setIsSearchBarFocused(false);
      }
    };
    $[34] = search;
    $[35] = setIsSearchBarFocused;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  let t15;
  let t16;
  if ($[37] !== isSearchBarFocused || $[38] !== setIsSearchBarFocused) {
    t15 = () => {
      if (isSearchBarFocused) {
        return;
      }
      setIsSearchBarFocused(true);
    };
    t16 = () => {
      if (!isSearchBarFocused) {
        return;
      }
      setTimeout(() => setIsSearchBarFocused(false), 10);
    };
    $[37] = isSearchBarFocused;
    $[38] = setIsSearchBarFocused;
    $[39] = t15;
    $[40] = t16;
  } else {
    t15 = $[39];
    t16 = $[40];
  }
  let t17;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = {
      "--fs": 16,
      "--lh": 20,
      fontWeight: 400,
      letterSpacing: "-0.008px"
    };
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] !== keyword || $[43] !== t12 || $[44] !== t13 || $[45] !== t14 || $[46] !== t15 || $[47] !== t16) {
    t18 = <input type="text" placeholder={t12} value={keyword} onChange={t13} onKeyDown={t14} onFocus={t15} onBlur={t16} className="fs flex-1 outline-none bg-transparent text-[#0F0F10] placeholder:text-[#86909C] min-w-0" style={t17 as React.CSSProperties} />;
    $[42] = keyword;
    $[43] = t12;
    $[44] = t13;
    $[45] = t14;
    $[46] = t15;
    $[47] = t16;
    $[48] = t18;
  } else {
    t18 = $[48];
  }
  let t19;
  if ($[49] !== handleClear || $[50] !== keyword) {
    t19 = keyword && <CustomButton onClick={handleClear} className="flex-shrink-0"><Icon src="/icons/clear-keyword.svg" alt="clear" width={20} /></CustomButton>;
    $[49] = handleClear;
    $[50] = keyword;
    $[51] = t19;
  } else {
    t19 = $[51];
  }
  let t20;
  if ($[52] !== t18 || $[53] !== t19) {
    t20 = <div className="flex-1 relative flex items-center gap-2 bg-[#F7F7F7] rounded px-4 py-2 border border-[#EAEBEC] min-w-0">{t11}{t18}{t19}</div>;
    $[52] = t18;
    $[53] = t19;
    $[54] = t20;
  } else {
    t20 = $[54];
  }
  let t21;
  if ($[55] !== t10 || $[56] !== t20) {
    t21 = <div className="flex items-center gap-3 px-4 py-[10px] w-full min-w-0">{t10}{t20}</div>;
    $[55] = t10;
    $[56] = t20;
    $[57] = t21;
  } else {
    t21 = $[57];
  }
  return t21;
};
export default SearchBar;
function _temp(region) {
  return region.id;
}